import { render, staticRenderFns } from "./CsvUploadComponent.vue?vue&type=template&id=28e8aa22&scoped=true"
import script from "./CsvUploadComponent.vue?vue&type=script&lang=js"
export * from "./CsvUploadComponent.vue?vue&type=script&lang=js"
import style0 from "./CsvUploadComponent.vue?vue&type=style&index=0&id=28e8aa22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8aa22",
  null
  
)

export default component.exports